import { useContext } from 'react';
import { LaunchContext } from './LaunchProvider';

/**
 * useLaunch — hook to access DraftKings Casino launch state from any component.
 *
 * Wallet operations are server-driven; the React shell does not move money.
 *
 * Session state:
 *   - launchParams    : parsed query parameters from the launch URL
 *   - session         : InitSession response (sessionId, balance, etc.)
 *   - isReady         : true once session is established
 *   - isLoading       : true while InitSession is in flight
 *   - isLoggedIn      : alias for isReady (backward compat)
 *   - error           : error string or null
 *   - balance         : player balance in cents
 *   - gemsBalance     : player gems balance in whole units (not divided by 100)
 *   - refreshBalance()  : re-reads the operator balance from rivalz-games-services
 *                         (call after entry or payout; server moves the money)
 *   - currencyCode    : session currency (DK: USD; Pixel: GEM/RCR) or null
 *   - displayName     : player username
 *
 * Navigation:
 *   - navigateToCashier() : opens the cashier URL
 *   - navigateToHome()    : navigates to the home/lobby URL
 */
export function useLaunch() {
  const context = useContext(LaunchContext);
  if (!context) {
    throw new Error('useLaunch must be used within a <LaunchProvider>');
  }
  return context;
}
